/**
 * Created by guga on 7/21/2016.
 */
export class RecipeRequisiteBean {
    public id : string; //IDENTIFIER OF THIS recipe
    public name: string; //Item name;
    public quantity:number;
    public use:boolean;
    public thumbnail:string
    public tokenId :string

    constructor (){
        let date=new Date();
        let time=date.getTime();
        this.id=time.toString(); //IDENTIFIER OF THIS recipe
        this.name=''
        this.use=false
        this.quantity=0
        this.thumbnail=''
        this.tokenId='';
    }

    public parse(val){
        if (val){
            this.id=val.id ? val.id : '-1'
            this.name=val.name ? val.name : ''
            this.use=val.use ? val.use : false
            this.quantity=val.quantity ? val.quantity : 0
            this.thumbnail=val.thumbnail  ? val.thumbnail : ''
            this.tokenId=val.tokenId ? val.tokenId   : ''
        }
        else{
            let date=new Date();
            let time=date.getTime();
            this.id=time.toString(); //IDENTIFIER OF THIS recipe
            this.name=''
            this.use=false
            this.quantity=0
            this.thumbnail=''   
            this.tokenId=''
        }
    }
    public toDB(){
        return {
            id:this.id,
            name:this.name,
            quantity:this.quantity,
            use:this.use,
            thumbnail:this.thumbnail,
            tokenId:this.tokenId
        }
    }

};




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/recipe.requisite.bean.ts